import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Eye, EyeSlash, Key } from "iconsax-react";
import "./form.css";

const DynamicForm = ({ schema, fields, onSubmit }) => {
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form-container">
      {fields.map((field) => (
        <div key={field.name} className="relative">
          <input
            {...register(field.name)}
            type={
              field.type === "password" && showPassword
                ? "text"
                : field.type || "text"
            }
            placeholder={field.placeholder}
            className="form-input"
          />
          {/* Toggle visibility icon for password fields */}
          {field.type === "password" && (
            <span
              className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? (
                <EyeSlash size="20" color="#5c4033" />
              ) : (
                <Eye size="20" color="#5c4033" />
              )}
            </span>
          )}
          <p className="form-error">{errors[field.name]?.message}</p>
        </div>
      ))}

      <button
        type="submit"
        className="form-button flex items-center justify-center gap-2"
      >
        <Key size="20" color="#ffffff" />
        Login
      </button>
    </form>
  );
};

export default DynamicForm;
